import {
	ChangePinPayload,
	GuestDetails,
	updateGuestDetails,
} from "@/api/register";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

type ChangePinArgs = {
	guestId: number;
	payload: ChangePinPayload;
};

export default function useChangePin(
	options?: MutationOptionsWithoutFn<GuestDetails, ChangePinArgs>,
) {
	return useMutation({
		mutationFn: ({ guestId, payload }: ChangePinArgs) =>
			updateGuestDetails(guestId, payload),
		...options,
	});
}
